import {useState} from 'react'
import {ConfirmationModal} from '../../../components/ConfirmationModal'
import Import from '../../../images/Import.png'

const ExportCSVButton = ({
  onExportCSV,
  hide,
  isLoading,
}: {
  onExportCSV: () => void
  hide: boolean
  isLoading: boolean
}) => {
  const [downloadCSVMessage, setDownloadCSVMessage] = useState<string>('')
  const [showDownloadCSVMessage, setShowDownloadCSVMessage] = useState<boolean>(false)
  const [isDownloadCSVLoading, setIsDownloadCSVLoading] = useState<boolean>(false)

  if (hide) return null

  const handleDownloadCSV = async () => {
    setIsDownloadCSVLoading(true)
    const response: any = await onExportCSV()
    if (response?.status >= 200 && response?.status < 300) {
      setDownloadCSVMessage(response.message)
      setShowDownloadCSVMessage(true)
    }
    setIsDownloadCSVLoading(false)
  }

  return (
    <>
      <button
        className='btn btn-outline'
        onClick={handleDownloadCSV}
        disabled={isDownloadCSVLoading || isLoading}
      >
        <div className='d-flex align-items-center'>
          <img src={Import} alt='Import File' className='me-2 import-icon' />
          <div className='d-flex align-items-center'>
            {isDownloadCSVLoading ? 'Exporting...' : 'Export CSV'}
            {isDownloadCSVLoading && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </div>
        </div>
      </button>
      {showDownloadCSVMessage && (
        <ConfirmationModal
          show={true}
          onClose={() => setShowDownloadCSVMessage(false)}
          title='Generating CSV'
          body={
            <div>
              <p>We are generating the data you requested for download as a CSV file.</p>
              <p>
                This process may take a few minutes. Once complete, the CSV will be sent to your
                email: <b>{downloadCSVMessage?.split(':')[1]}</b>
              </p>
            </div>
          }
          onAction={() => setShowDownloadCSVMessage(false)}
          disableAction={true}
          okayBtnClass='btn-primary'
        />
      )}
    </>
  )
}

export default ExportCSVButton
